var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9655 4.44558H11.0471L10.5901 3.16477C10.5585 3.07713 10.5006 3.00137 10.4244 2.94784C10.3482 2.89432 10.2572 2.86564 10.1641 2.86572H5.8364C5.64597 2.86572 5.47529 2.98562 5.41181 3.16477L4.95337 4.44558H3.03497C2.41149 4.44558 1.90649 4.95058 1.90649 5.57406V12.0063C1.90649 12.6298 2.41149 13.1348 3.03497 13.1348H12.9655C13.589 13.1348 14.094 12.6298 14.094 12.0063V5.57406C14.094 4.95058 13.589 4.44558 12.9655 4.44558ZM8.00024 10.8779C6.75328 10.8779 5.7433 9.86789 5.7433 8.62093C5.7433 7.37397 6.75328 6.36399 8.00024 6.36399C9.24721 6.36399 10.2572 7.37397 10.2572 8.62093C10.2572 9.86789 9.24721 10.8779 8.00024 10.8779ZM6.64608 8.62093C6.64608 8.98008 6.78875 9.32452 7.0427 9.57847C7.29666 9.83243 7.6411 9.9751 8.00024 9.9751C8.35939 9.9751 8.70383 9.83243 8.95778 9.57847C9.21174 9.32452 9.35441 8.98008 9.35441 8.62093C9.35441 8.26178 9.21174 7.91735 8.95778 7.66339C8.70383 7.40943 8.35939 7.26676 8.00024 7.26676C7.6411 7.26676 7.29666 7.40943 7.0427 7.66339C6.78875 7.91735 6.64608 8.26178 6.64608 8.62093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.56646e1359b8dd00e53c0972ec52ecc2.svg";
export { ForwardRef as ReactComponent };